var map = {
	"./BUILDING_STATE": 4506,
	"./BUILDING_STATE-4-fails": 2623,
	"./BUILDING_STATE-4-fails.js": 2623,
	"./BUILDING_STATE-end": 5587,
	"./BUILDING_STATE-end-FUNDED": 1519,
	"./BUILDING_STATE-end-FUNDED.js": 1519,
	"./BUILDING_STATE-end.js": 5587,
	"./BUILDING_STATE-funded-buildings": 7441,
	"./BUILDING_STATE-funded-buildings.js": 7441,
	"./BUILDING_STATE-one": 5020,
	"./BUILDING_STATE-one.js": 5020,
	"./BUILDING_STATE.js": 4506,
	"./FULL_STATE": 3632,
	"./FULL_STATE.js": 3632,
	"./KINGDOM_STATE": 9612,
	"./KINGDOM_STATE-victory": 2745,
	"./KINGDOM_STATE-victory.js": 2745,
	"./KINGDOM_STATE.js": 9612,
	"./NOBLE_STATE": 4431,
	"./NOBLE_STATE.js": 4431,
	"./POLL_STEP": 9888,
	"./POLL_STEP.js": 9888,
	"./REBELLION_STATE": 1181,
	"./REBELLION_STATE-cheifs": 8560,
	"./REBELLION_STATE-cheifs.js": 8560,
	"./REBELLION_STATE-has-duplicate": 6386,
	"./REBELLION_STATE-has-duplicate.js": 6386,
	"./REBELLION_STATE-small": 4297,
	"./REBELLION_STATE-small.js": 4297,
	"./REBELLION_STATE.js": 1181,
	"./REBELLION_STATE2": 6839,
	"./REBELLION_STATE2.js": 6839,
	"./REGION_STATE": 4247,
	"./REGION_STATE-victory": 9541,
	"./REGION_STATE-victory.js": 9541,
	"./REGION_STATE-with-scheme": 865,
	"./REGION_STATE-with-scheme-OTHER": 9738,
	"./REGION_STATE-with-scheme-OTHER.js": 9738,
	"./REGION_STATE-with-scheme.js": 865,
	"./REGION_STATE.js": 4247,
	"./TURN_STATE-1": 2591,
	"./TURN_STATE-1.js": 2591,
	"./TURN_STATE-2": 3329,
	"./TURN_STATE-2.js": 3329,
	"./VOTE_STEP": 9778,
	"./VOTE_STEP-both": 7758,
	"./VOTE_STEP-both.js": 7758,
	"./VOTE_STEP-both2": 8418,
	"./VOTE_STEP-both2.js": 8418,
	"./VOTE_STEP-end": 937,
	"./VOTE_STEP-end.js": 937,
	"./VOTE_STEP-locked-rebelion": 2247,
	"./VOTE_STEP-locked-rebelion.js": 2247,
	"./VOTE_STEP-monarchs-choice": 8679,
	"./VOTE_STEP-monarchs-choice.js": 8679,
	"./VOTE_STEP-not-open": 2935,
	"./VOTE_STEP-not-open.js": 2935,
	"./VOTE_STEP-successor": 5263,
	"./VOTE_STEP-successor.js": 5263,
	"./VOTE_STEP-veto": 1461,
	"./VOTE_STEP-veto.js": 1461,
	"./VOTE_STEP.js": 9778,
	"./scheme": 9977,
	"./scheme-end": 7764,
	"./scheme-end.js": 7764,
	"./scheme-italics-vote": 9118,
	"./scheme-italics-vote.js": 9118,
	"./scheme.js": 9977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7590;